export enum ReadyWithin {
  THIRTY_MINUTES = "30 minutes",//$localize`:@@30Minutes:30 minutes.`,
  ONE_HOUR = "1 hour",
  TWO_HOURS = "2 hours",
  NEXT_DAY = "Next day",
  TWO_DAYS = "2 days"
}

export class ReadyWithinEnumMapper {
  static toString(readyWithin: string): string {
    if (readyWithin === "30MINUTES") {
      return $localize`:@@30Minutes:30 minutes`
    } else if (readyWithin === "1HOUR") {
      return $localize`:@@1Hour:1 hour`
    } else if (readyWithin === "2HOURS") {
      return $localize`:@@2Hours:2 hours` //ReadyWithin.TWO_HOURS
    } else if (readyWithin === "NEXT_DAY") {
      return $localize`:@@nextDay:Next day`
    } else if (readyWithin === "2DAYS") {
      return $localize`:@@2Days:2 days` //ReadyWithin.TWO_DAYS
    } else {
      return  ""
    }
  }
}
